import { createMemoryHistory, createRouter, createWebHistory, type Router } from 'vue-router'

export const createVueRouter = (): Router =>
  createRouter({
    history: import.meta.env.SSR ? createMemoryHistory('/') : createWebHistory('/'),
    scrollBehavior: (to, _from, savedPosition) => {
      if (savedPosition) return savedPosition
      if (to.hash) return { el: to.hash, behavior: 'smooth' }
      return { top: 0 }
    },
    routes: [
      {
        path: '/',
        name: 'home.index',
        component: () => import('@/pages/home/Index.vue'),
      },
      {
        path: '/agents',
        name: 'campaigns.agents',
        component: () => import('@/pages/campaigns/agents.vue'),
      },
      {
        path: '/gloriafood',
        name: 'campaigns.gloriafood',
        component: () => import('@/pages/campaigns/gloriafood.vue'),
      },
      {
        path: '/producten/webshop',
        name: 'products.webshop',
        component: () => import('@/pages/products/Webshop.vue'),
      },
      {
        path: '/producten/website',
        name: 'products.page',
        component: () => import('@/pages/products/Page.vue'),
      },
      {
        path: '/producten/posdevice',
        name: 'products.posdevice',
        component: () => import('@/pages/products/Posdevice.vue'),
      },
      {
        path: '/producten/pos',
        name: 'products.pos',
        component: () => import('@/pages/products/Pos.vue'),
      },
      {
        path: '/producten/qr',
        name: 'products.qr',
        component: () => import('@/pages/products/Qr.vue'),
      },
      {
        path: '/producten/manager',
        name: 'products.manager',
        component: () => import('@/pages/products/Manager.vue'),
      },
      {
        path: '/producten/kiosk',
        name: 'products.kiosk',
        component: () => import('@/pages/products/Kiosk.vue'),
      },
      {
        path: '/prijzen',
        name: 'pricing.index',
        component: () => import('@/pages/pricing/Index.vue'),
      },
      {
        path: '/cases/lunchroom',
        name: 'cases.lunchroom',
        component: () => import('@/pages/cases/Lunchroom.vue'),
      },
      {
        path: '/cases/sushi',
        name: 'cases.sushi',
        component: () => import('@/pages/cases/Sushi.vue'),
      },
      {
        path: '/cases/cafetaria',
        name: 'cases.cafetaria',
        component: () => import('@/pages/cases/Cafetaria.vue'),
      },
      {
        path: '/cases/italian',
        name: 'cases.italian',
        component: () => import('@/pages/cases/Italian.vue'),
      },
      {
        path: '/cases/grillroom',
        name: 'cases.grillroom',
        component: () => import('@/pages/cases/Grillroom.vue'),
      },

      {
        path: '/downloads',
        name: 'info.downloads',
        component: () => import('@/pages/info/Downloads.vue'),
      },

      {
        path: '/blog',
        name: 'blogs.index',
        component: () => import('@/pages/blogs/Index.vue'),
      },
      {
        path: '/blog/:slug',
        name: 'blogs.show',
        component: () => import('@/pages/blogs/Show.vue'),
      },

      {
        path: '/integraties',
        name: 'info.integrations',
        component: () => import('@/pages/info/Integrations.vue'),
      },
      {
        path: '/integraties/lightspeed',
        name: 'integrations.lightspeed',
        component: () => import('@/pages/integrations/Lightspeed.vue'),
      },
      {
        path: '/integraties/mollie',
        name: 'integrations.mollie',
        component: () => import('@/pages/integrations/Mollie.vue'),
      },
      {
        path: '/integraties/stripe',
        name: 'integrations.stripe',
        component: () => import('@/pages/integrations/Stripe.vue'),
      },
      {
        path: '/integraties/exact-online',
        name: 'integrations.exact',
        component: () => import('@/pages/integrations/ExactOnline.vue'),
      },
      {
        path: '/integraties/google',
        name: 'integrations.google',
        component: () => import('@/pages/integrations/Google.vue'),
      },
      {
        path: '/integraties/winstonpos',
        name: 'integrations.winstonpos',
        component: () => import('@/pages/integrations/WinstonPOS.vue'),
      },
      {
        path: '/integraties/untill',
        name: 'integrations.untill',
        component: () => import('@/pages/integrations/Untill.vue'),
      },
      {
        path: '/integraties/mplus-kassa',
        name: 'integrations.mpluskassa',
        component: () => import('@/pages/integrations/MplusKassa.vue'),
      },
      {
        path: '/integraties/twilio',
        name: 'integrations.twilio',
        component: () => import('@/pages/integrations/Twilio.vue'),
      },
      {
        path: '/integraties/facebook',
        name: 'integrations.facebook',
        component: () => import('@/pages/integrations/Facebook.vue'),
      },
      {
        path: '/integraties/cashdesk',
        name: 'integrations.cashdesk',
        component: () => import('@/pages/integrations/Cashdesk.vue'),
      },
      {
        path: '/integraties/leat',
        name: 'integrations.leat',
        component: () => import('@/pages/integrations/Leat.vue'),
      },
      {
        path: '/integraties/instagram',
        name: 'integrations.instagram',
        component: () => import('@/pages/integrations/Instagram.vue'),
      },
      {
        path: '/integraties/slack',
        name: 'integrations.slack',
        component: () => import('@/pages/integrations/Slack.vue'),
      },
      {
        path: '/info/support',
        name: 'info.support',
        component: () => import('@/pages/info/Support.vue'),
      },
      {
        path: '/info/faq',
        name: 'info.faq',
        component: () => import('@/pages/info/Faq.vue'),
      },
      {
        path: '/customer-support',
        name: 'customer.support',
        component: () => import('@/pages/info/Faq.vue'),
      },
      {
        path: '/terms-and-conditions',
        name: 'info.terms',
        component: () => import('@/pages/info/terms.vue'),
      },
      {
        path: '/algemene-voorwaarden',
        name: 'info.terms.nl',
        component: () => import('@/pages/info/terms.vue'),
      },
      {
        path: '/privacy-policy',
        name: 'avg.index',
        component: () => import('@/pages/avg/Index.vue'),
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/errors/404.vue'),
        name: 'not-found',
      },
    ],
  })
